import * as RadixSlider from '@radix-ui/react-slider';
import { forwardRef } from 'react';

import { cn } from '../../utils/cn';

/**
 * Slider wrapper that styles `@radix-ui/react-slider`.
 *
 * Accessibility — Radix Slider already wires aria-valuemin/max/now from the
 * `min/max/value` props; we add a visible track/range/thumb visual.
 */
export const Slider = forwardRef(function Slider({ className, 'aria-label': ariaLabel, ...props }, ref) {
  return (
    <RadixSlider.Root
      ref={ref}
      aria-label={ariaLabel}
      data-ds-id="ds/input/slider--default"
      className={cn(
        'relative flex h-space-6 w-full touch-none select-none items-center',
        className,
      )}
      {...props}
    >
      <RadixSlider.Track className="relative h-space-2 w-full grow overflow-hidden rounded-ds-full bg-stone-200 dark:bg-stone-700">
        <RadixSlider.Range className="absolute h-full bg-gradient-to-r from-sage-400 to-sage-600" />
      </RadixSlider.Track>
      <RadixSlider.Thumb
        className="block size-space-6 rounded-ds-full border-2 border-sage-500 bg-card shadow-[0_4px_14px] shadow-sage-glow transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        aria-label={ariaLabel || 'valor'}
      />
    </RadixSlider.Root>
  );
});
